import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Row, Col, Button, Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import Select from "react-select";
import moment from "moment";
import { Cache } from "aws-amplify";

import {
  fetchProjectByRole,
  getProjectsJSON,
  fetchProjects,
} from "../../store/actions/projects/projectsActions";
import { fetchProjectMembers } from "../../store/actions/projects/projectMembersActions";
import { fetchTasks } from "../../store/actions/projects/tasksActions";
import { fetchCostCenters } from "../../store/actions/cost_centers/costCenterActions";
import {
  refreshReports,
  getProductivityReport,
  generateExportData,
  getAccomplishmentReport,
} from "../../store/actions/reports/reportsActions";
import {
  PENDING,
  APPROVED,
  REJECTED,
  REGULAR,
  OVERTIME,
} from "../../store/actions/timesheet/timesheetActions";
import {
  fetchUsers,
  PORTAL_ADMIN,
  PROJECT_SPONSOR,
  EMPLOYEE,
  MANAGER,
  PROJECT_ADMIN,
  TEAM_LEADER,
  HR_ADMIN,
  FINANCE_APPROVER,
  FINANCE_REPORTER,
} from "../../store/actions/users/usersActions";
import { getCurrentCostCenter } from "../../store/actions/cost_centers/userCostCenterActions";
import { drawTable } from "../../common/Utilities";

import "../../css/reports.css";

import PageTitle from "../../common/PageTitle";
import ExportReport from "./ExportReport";

class WeeklyMonthlyReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reRender: false,
    };

    this.buttonId = "generateReport";

    this.statusList = [APPROVED];

    this.statuses = this.statusList;
    this.projectId = [];
    this.projectMemberId = 0;
    this.costCenter = 0;
    this.startDate = new Date(moment().subtract(1, "weeks").startOf("isoWeek"));
    this.endDate = new Date(moment().subtract(1, "weeks").endOf("isoWeek"));
    this.startMaxDate = this.startDate;
    this.endMinDate = this.endDate;

    this.members = {};
    this.empIds = {};
    this.costCenters = {};

    this.memberIds = [];
    this.projects = [];

    this.showTable = false;

    this.roleId = Cache.getItem("roleId") || 0;
    this.userId = Cache.getItem("userId");
  }

  componentWillUnmount() {
    this.props.refreshReports();

    Cache.removeItem("exportHeaders");
    Cache.removeItem("exportData");
    Cache.removeItem("keyValues");
  }

  componentDidMount() {
    this.props.fetchProjects({ status: APPROVED, is_disabled: 0 });
    this.props.fetchCostCenters();
    this.props.fetchProjectByRole();
    this.props.fetchTasks();
    this.enableGenerateButton();

    this.minDate = "";
    this.maxDate = new Date();

    if (this.roleId === MANAGER || this.roleId === TEAM_LEADER) {
      document.getElementById(this.buttonId).disabled = true;
    }

    if (this.roleId === TEAM_LEADER) {
      const subordinatesFilter = {
        supervisor_id: this.userId,
      };
      this.props.fetchUsers(subordinatesFilter);
    } else if (
      [PORTAL_ADMIN, HR_ADMIN, FINANCE_REPORTER, FINANCE_APPROVER].includes(
        this.roleId
      )
    ) {
      this.props.fetchUsers();
    }
  }

  displayStatusCheckboxes = () => {
    return this.statusList.map((status, key) => {
      return (
        <Form.Check
          type="checkbox"
          defaultChecked={true}
          inline={true}
          label={status}
          value={status}
          id={status + "id"}
          className="weekly-report-checkbox"
          key={key}
        />
      );
    });
  };

  displayProjectDropDown = () => {
    let isAdmin =
      this.roleId === PORTAL_ADMIN ||
      this.roleId === PROJECT_ADMIN ||
      this.roleId === HR_ADMIN ||
      this.roleId === FINANCE_APPROVER ||
      this.roleId === FINANCE_REPORTER
        ? true
        : false;

    let projectsJSON = this.props.getProjectsJSON(
      { includeGenAdmin: true, is_disabled: 0 },
      isAdmin
    );

    //generate project arrays
    this.projects = projectsJSON.map((project) => {
      return project.value;
    });

    const selectClass = "projectSelect";

    return (
      <Col xs={3} sm={3} md={3} lg={3} xl={3}>
        <Select
          className={selectClass}
          classNamePrefix={selectClass}
          placeholder={"Select Project"}
          size="sm"
          onChange={(selectedOption) => {
            this.projectId = [selectedOption.value];
            if (this.projectId) {
              if (this.projectId === "all") {
                this.projectId = this.projects;
              }

              this.props.fetchProjectMembers(this.projectId);
            }

            this.changeMinDate();
            this.enableGenerateButton();

            this.props.refreshReports();
          }}
          options={projectsJSON}
        />
      </Col>
    );
  };

  // displayMembersDropdown = () => {
  //   let members = [];
  //   const currentUser = this.props.users.currentUser;
  //   if (currentUser) {
  //     members = [currentUser];
  //   }
  //   const selectClass = "memberSelect";

  //   if (this.roleId === MANAGER || this.roleId === PROJECT_SPONSOR) {
  //     const projects = this.props.projects.projectMembers;
  //     if (projects && projects.length) {
  //       members = [
  //         ...members,
  //         ...projects
  //           .filter((data) => {
  //             if (typeof data.user !== "undefined") {
  //               const user = data.user;
  //               if (!user) {
  //                 return null;
  //               }

  //               if (user.id !== currentUser.id) {
  //                 return data;
  //               }
  //             }
  //             return false;
  //           })
  //           .map((project) => project.user),
  //       ];
  //     }
  //   } else if (
  //     this.roleId === TEAM_LEADER ||
  //     this.roleId === PORTAL_ADMIN ||
  //     this.roleId === HR_ADMIN ||
  //     this.roleId === FINANCE_APPROVER ||
  //     this.roleId === FINANCE_REPORTER ||
  //     this.roleId === PROJECT_ADMIN
  //   ) {
  //     const users = this.props.users;

  //     if (users && users.users) {
  //       members = [...members, ...users.users];
  //     }
  //   } else if (this.roleId === EMPLOYEE) {
  //     this.projectMemberId = this.userId;
  //     this.members[this.userId] = this.getFullName(currentUser);
  //     if (
  //       currentUser.employee_id &&
  //       typeof currentUser.employee_id !== "undefined"
  //     ) {
  //       this.empIds[this.userId] = currentUser.employee_id
  //         .toString()
  //         .padStart(5, "0");
  //     }

  //     if (currentUser.user_cost_center) {
  //       this.costCenters[this.userId] = currentUser.user_cost_center;
  //     }

  //     return "";
  //   }
  //
  // let memberList = [
  //   {
  //     key: 0,
  //     value: "all",
  //     label: "--SELECT ALL MEMBERS--",
  //   },
  // ];

  // if (members && members.length) {
  //   this.memberIds = members.map((member) => {
  //     if (member) {
  //       return member.id;
  //     }
  //     return false;
  //   });

  //   members.forEach((member) => {
  //     if (Object.keys(member).length) {
  //       const fullName = this.getFullName(member);
  //       const costCenter = member.user_cost_center;
  //       memberList.push({
  //         key: member.id,
  //         value: member.id,
  //         label: fullName,
  //       });

  //       if (!(member.id in this.members)) {
  //         this.members[member.id] = fullName;
  //         if (
  //           member.employee_id &&
  //           typeof member.employee_id !== "undefined"
  //         ) {
  //           this.empIds[member.id] = member.employee_id
  //             .toString()
  //             .padStart(5, "0");
  //         }

  //         if (costCenter) {
  //           this.costCenters[member.id] = costCenter;
  //         }
  //       }
  //     }
  //   });
  // }

  //   return (
  //     <Col xs={3} sm={3} md={3} lg={3} xl={3}>
  //       <Select
  //         className={selectClass}
  //         classNamePrefix={selectClass}
  //         size="sm"
  //         onChange={(selectedOption) => {
  //           this.projectMemberId = selectedOption.value;

  //           this.enableGenerateButton();
  //           this.props.refreshReports();
  //         }}
  //         options={memberList}
  //       />
  //     </Col>
  //   );
  // };

  displayCostCenterFilter = () => {
    if (this.roleId !== FINANCE_REPORTER) {
      return "";
    }

    const selectClass = "costCenterSelect";
    let costCenterList = [];

    const costCenters = this.props.costCenters.costCenters;

    if (costCenters.length) {
      costCenterList = [
        {
          key: 0,
          value: 0,
          label: "--SELECT ALL COST CENTERS--",
        },
      ];

      costCenters.forEach((costCenter) => {
        costCenterList.push({
          key: costCenter.id,
          value: costCenter.id,
          label:
            costCenter.cost_center_code + " - " + costCenter.cost_center_name,
        });
      });
    }

    return (
      <Col xs={3} sm={3} md={3} lg={3} xl={3}>
        <Select
          className={selectClass}
          classNamePrefix={selectClass}
          size="sm"
          onChange={(selectedOption) => {
            this.costCenter = selectedOption.value;

            this.enableGenerateButton();
            this.props.refreshReports();
          }}
          options={costCenterList}
        />
      </Col>
    );
  };

  enableGenerateButton = () => {
    if (
      this.projectId ||
      (this.roleId === FINANCE_REPORTER && this.costCenter)
    ) {
      document.getElementById(this.buttonId).disabled = false;
    } else {
      document.getElementById(this.buttonId).disabled = true;
    }
  };

  getFullName = (member) => {
    if (member && typeof member !== "undefined") {
      const firstName = member.first_name || "";
      const middleName = member.middle_name || "";
      const lastName = member.last_name || "";
      return lastName + ", " + firstName + " " + middleName;
    }
  };

  changeMinDate = () => {
    const projects = this.props.projects.projectsByRole;
    const projectId = this.projectId;

    if (projects && projects.length && projectId) {
      const project = projects
        .filter((project) => project.id === projectId)
        .pop();
      if (project && project.start_date) {
        this.minDate = new Date(project.start_date);
      }
    }
  };

  displayStartDate = () => {
    return (
      <DatePicker
        placeholderText="Start Date"
        minDate={this.minDate}
        maxDate={this.maxDate}
        onChange={(date) => {
          this.startDate = date;
          this.endMinDate = date;
          this.props.refreshReports();
        }}
        selected={this.startDate}
      />
    );
  };

  displayEndDate = () => {
    return (
      <DatePicker
        placeholderText="End Date"
        minDate={this.minDate}
        onChange={(date) => {
          this.endDate = date;
          this.startMaxDate = date;
          this.props.refreshReports();
        }}
        selected={this.endDate}
      />
    );
  };

  displayGenerateButton = () => {
    return (
      <Button
        id={this.buttonId}
        onClick={() => {
          this.showTable = true;
          this.statuses = Array.from(
            document.querySelectorAll('input[type="checkbox"]:checked')
          ).map((checkbox) => checkbox.value);
          if (!this.statuses.length) {
            this.statuses = this.statusList;
          }

          if (this.projectId === "all") {
            this.projectId = this.projects;
          }

          this.props.getAccomplishmentReport({
            project_id: this.projectId,
            user_id: [this.props.users.currentUser.id],
            start_date: this.startDate,
            end_date: this.endDate,
          });
        }}
      >
        Generate Report
      </Button>
    );
  };

  generateData = () => {
    let projects =
      this.props.projects.projectsByRole || this.props.projects.projects;

    const tasks = this.props.tasks.tasks;
    const accomplishmentReport = this.props.reports.accomplishmentReport;

    let exportData = [];
    let tableRows = [];

    //Populate header from the data

    let tableHeaders = [
      "Activity #",
      "Project Name",
      "Activity/Task",
      "Frequency",
      "Monthly Target",
      "Actual Transactions",
      "Exceeding Target",
      "Remarks",
    ];

    //split regular and overtime into separate rows
    let timeEntries = [];

    accomplishmentReport.length &&
      accomplishmentReport.forEach((entry) => {
        timeEntries.push(entry);
      });

    if (projects && tasks && tasks.length) {
      let projectName = "";
      let taskName = "";

      let entries = [];

      if (timeEntries && timeEntries.length) {
        timeEntries.map((entry, index) => {
          const employeeId = this.empIds[entry.user_id] || "";
          const userName = this.members[entry.user_id] || "";
          const costCenter =
            getCurrentCostCenter(
              this.costCenters[entry.user_id],
              entry.time_entry_date
            ) || "";

          const thisProject =
            projects &&
            projects.filter((project) => project.id === entry.project_id).pop();

          if (typeof thisProject !== "undefined") {
            projectName = thisProject && thisProject.project_name;

            taskName = thisProject.project_tasks
              .filter((task) => task.id === entry.task_id)
              .map((task) => task.name)
              .pop();
          }

          let pendingApprovers = "";
          let approversList = [];

          for (
            let currentSequence = 0;
            currentSequence < 50;
            currentSequence++
          ) {
            approversList =
              "approvers" in entry &&
              entry.approvers
                .filter(
                  (approver) =>
                    approver.status === PENDING &&
                    approver.sequence === currentSequence
                )
                .map(
                  (approver) => approver.last_name + ", " + approver.first_name
                );
            if (approversList.length) {
              break;
            }
          }

          if (approversList.length) {
            pendingApprovers = approversList.map((approver, index) =>
              index ? approver + "\n" : approver
            );
          }

          let row = {
            activityNumber: index + 1,
            // date: moment(entry.time_entry_date).format("MMM DD, YYYY"),
            projectName: projectName,
            taskName: entry.task_name,
            frequency: entry.frequency,
            monthlyTarget: entry.target,
            actualTransactions: entry.total_actual_transaction,
            exceedingTarget: entry.exceeding_transaction,
            remarks: entry.remarks && entry.remarks.length > 0 
              ? entry.remarks.filter(r => r !== "[]").join(", ")
              : "",

            // remarks: entry.remarks && entry.remarks.length > 0 ? `"${JSON.stringify(entry.remarks)}"` : "",
          };

          if (this.roleId === FINANCE_REPORTER) {
            row.costCenter = costCenter ? costCenter.cost_center_name : "";
          }

          entries.push(row);
        });
      }

      if (entries && entries.length) {
        let rowKeys = [];
        entries.forEach((entry) => {
          let row = [];
          let exportRow = {};

          for (const key in entry) {
            const column = entry[key];
            row.push(column);
            exportRow = Object.assign(exportRow, {
              [key]: column,
            });
          }

          rowKeys = Object.keys(entry);

          exportData.push(exportRow);
          tableRows.push(row);
        });

        // sort by project name
        // tableRows.sort((a, b) => a[1].localeCompare(b[1]));
        // exportData.sort((a, b) => a.projectName.localeCompare(b.projectName));

        return {
          rowKeys,
          exportData,
          tableHeaders,
          tableRows,
        };
      } else {
        return null;
      }
    } else {
      return null;
    }
  };

  displayWeeklyMonthlyReport = () => {
    let tableData = {};
    tableData.headerClass = "align-center";

    tableData.headers = [];
    tableData.body = [];

    let result = this.generateData();

    if (result) {
      tableData.headers = result.tableHeaders;
      tableData.body = result.tableRows;

      this.exportData = result.exportData;
      this.exportHeaders = result.tableHeaders;
    } else {
      tableData.body = null;
    }

    // return drawTable(tableData, this.showTable);
  };

  generateExportButton() {
    if (!this.showTable || !this.exportData || !this.exportHeaders) {
      return "";
    }

    const data = generateExportData(this.exportHeaders, this.exportData);

    console.log(data);

    return (
      <ExportReport
        fileName={`accomplishment_report_${data[1][1]}`}
        data={data}
      />
    );
  }

  displayFilterDropdowns = () => {
    let dropdowns = "";
    if (this.roleId === TEAM_LEADER) {
      dropdowns = (
        <>
          {/* {this.displayMembersDropdown()} */}
          {this.displayProjectDropDown()}
        </>
      );
    } else {
      dropdowns = (
        <>
          {this.displayProjectDropDown()}
          {/* {this.displayMembersDropdown()} */}
          {this.displayCostCenterFilter()}
        </>
      );
    }
    return <>{dropdowns}</>;
  };

  render() {
    return (
      <React.Fragment>
        <PageTitle pageName="Accomplishment Report" />
        <Row className="mt-3 mb-3">
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            {/* {this.displayStatusCheckboxes()} */}
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <Row>
              {this.roleId !== FINANCE_REPORTER ? (
                <>
                  {this.displayFilterDropdowns()}
                  <Col xs={2} sm={2} md={2} lg={2} xl={2}>
                    {this.displayStartDate()}
                  </Col>
                  <Col xs={2} sm={2} md={2} lg={2} xl={2}>
                    {this.displayEndDate()}
                  </Col>
                  <Col xs={2} sm={2} md={2} lg={2} xl={2}>
                    {this.displayGenerateButton()}
                  </Col>
                </>
              ) : (
                this.displayFilterDropdowns()
              )}
            </Row>
            <Row className="mt-3">
              {this.roleId === FINANCE_REPORTER ? (
                <>
                  <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                    {this.displayStartDate()}
                  </Col>
                  <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                    {this.displayEndDate()}
                  </Col>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    {this.displayGenerateButton()}
                  </Col>
                </>
              ) : (
                ""
              )}
            </Row>
            <Row className="mt-3"></Row>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            {this.displayWeeklyMonthlyReport()}
          </Col>
        </Row>
        <Row>{this.generateExportButton()}</Row>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  projects: state.projects,
  reports: state.reports,
  tasks: state.tasks,
  users: state.users,
  costCenters: state.costCenters,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getProjectsJSON: (...args) => dispatch(getProjectsJSON(...args)),
    fetchProjectByRole: (...args) => dispatch(fetchProjectByRole(...args)),
    getAccomplishmentReport: (...args) =>
      dispatch(getAccomplishmentReport(...args)),
    fetchProjectMembers: (...args) => dispatch(fetchProjectMembers(...args)),
    refreshReports: (...args) => dispatch(refreshReports(...args)),
    fetchTasks: (...args) => dispatch(fetchTasks(...args)),
    fetchUsers: (...args) => dispatch(fetchUsers(...args)),
    fetchProjects: (...args) => dispatch(fetchProjects(...args)),
    fetchCostCenters: () => dispatch(fetchCostCenters()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(WeeklyMonthlyReports)
);
